module.exports = __webpack_public_path__ + "build/desktop/a/img/nutrition-icon.b746c227b0aae74980cc5bae42e16d1c.svg";